import Vue from 'vue';

export default Vue.extend({
  name: 'App',
});



// WEBPACK FOOTER //
// ./src/js/app.js